import { socketActionTypes } from './socket.types';

export const socketConnectRequested = (namespace) => ({
    type: socketActionTypes.SOCKET_CONNECT_REQUESTED,
    payload: { namespace },
});

export const socketDisconnectRequested = (namespace) => ({
    type: socketActionTypes.SOCKET_DISCONNECT_REQUESTED,
    payload: { namespace },
});

export const socketStatusChanged = (namespace, status, lastError = null) => ({
    type: socketActionTypes.SOCKET_STATUS_CHANGED,
    payload: { namespace, status, lastError },
});

export const socketConnectFailed = (namespace, error) => ({
    type: socketActionTypes.SOCKET_CONNECT_FAILED,
    payload: { namespace, error },
});
